import InputDateTimeKendo from './input-datetime-kendo.component'

export default InputDateTimeKendo